var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-score-sum"},[_c('div',{staticClass:"l-score"},[_c('h3',[_vm._v(_vm._s(_vm.right)+" / "+_vm._s(_vm.total))]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',[_vm._v("正确")]),_c('span',[_vm._v("总数")])])
}]

export { render, staticRenderFns }